import { getTimezone } from 'countries-and-timezones';

export function getLocale(): string {
  return document.documentElement.lang.trim() || navigator.language || 'en-US';
}

function localeToCountryCode(locale: string): string | null {
  const parts = locale
    .split(/[-_]/)
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length < 2) return null;

  const region = parts.find((part, index) => index > 0 && /^[a-z]{2}$/i.test(part));
  return region ? region.toUpperCase() : null;
}

export function getApexCountryCode(): string | null {
  const stamped = document
    .querySelector<HTMLMetaElement>('meta[name="apex-country"]')
    ?.content.trim()
    .toUpperCase();

  return stamped || null;
}

export function getBrowserTimeZone(): string | null {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
}

function timeZoneToCountryCode(timeZone: string | null): string | null {
  if (!timeZone) return null;

  const timezone = getTimezone(timeZone);
  return timezone?.countries[0] ?? null;
}

export function getDefaultCountryCode(): string | null {
  const countryFromApex = getApexCountryCode();
  if (countryFromApex) return countryFromApex;

  const countryFromTimeZone = timeZoneToCountryCode(getBrowserTimeZone());
  if (countryFromTimeZone) return countryFromTimeZone;

  const locales = navigator.languages.length > 0 ? navigator.languages : [navigator.language];

  for (const locale of locales) {
    if (!locale) continue;

    const countryCode = localeToCountryCode(locale);
    if (countryCode) return countryCode;
  }

  return null;
}
